/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotesTemplate } from '../../models/notes-template';

export interface NotesTemplateGet$Params {
  id: number;
}

export function notesTemplateGet(http: HttpClient, rootUrl: string, params: NotesTemplateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<NotesTemplate>> {
  const rb = new RequestBuilder(rootUrl, notesTemplateGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NotesTemplate>;
    })
  );
}

notesTemplateGet.PATH = '/api/NotesTemplate/{id}';
